var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/DKT/Close/black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-Thank-You-Page",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DKT-Purchase-not-succesful-Neu",
    transform: "translate(-709.000000, -212.000000)",
    stroke: "currentColor",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(697.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/DKT/Close/black",
    transform: "translate(14.540000, 14.540000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SO-Iconset-SVGs_White---Close-X",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.1512,
    y1: 0.1512,
    x2: 17.2088,
    y2: 17.2088,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.1512,
    y1: 17.2088,
    x2: 17.2088,
    y2: 0.1512,
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.d19ae0ac228f0ae4c95d7184410565b7.svg";
export { ForwardRef as ReactComponent };